<!-- hospital.component.html -->
<p-toast></p-toast>

<div class="card">
  <h2>Registro de antibiotico</h2>
  
  <form [formGroup]="catalogoForm" (ngSubmit)="onSubmit()">
    <div class="p-fluid p-formgrid p-grid">
      
      <!-- Nombre Hospital -->
      <div class="p-field p-col-12 p-md-6">
        <label for="descripcon">Descripcion</label>
        <input 
          id="descripcon"
          type="text"
          pInputText
          formControlName="descripcion"
          class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          [ngClass]="{'ng-invalid ng-dirty': f['descripcion'].touched && f['descripcion'].errors}">
        <small class="p-error" *ngIf="f['descripcion'].touched && f['descripcion'].errors?.['required']">
          La descripcon es requerida
        </small>
        <small class="p-error" *ngIf="f['descripcion'].touched && f['descripcion'].errors?.['minlength']">
          El descripcon debe tener al menos 3 caracteres
        </small>
      </div>  
      
    </div>
     <!-- Botones -->
     <div class="field col-12 md:col-4">
        <p-button 
        type="submit"
        label="Guardar"
        icon="pi pi-save"
        [disabled]="catalogoForm.invalid">
      </p-button>
    </div> 
    
  </form>
</div>
